var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$device.isMobile)?_c('div',[_c('nuxt')],1):_c('div',{staticClass:"body-container"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('nuxt')],1),_vm._v(" "),_c('Footer')],1),_vm._v(" "),_c('portal-target',{attrs:{"name":"destination"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }